import _ from 'lodash';
import React from 'react';

import {KYC_SECTIONS_META} from 'ducks/bookings';
import classNames from 'classnames';

import './styles.css';

const Navigation = ({changeSelectedSectionType, selectedSectionType}) => (
  <div className="Navigation colab-centered-v">
    {_.keys(KYC_SECTIONS_META).map(key => (
      <div
        key={key}
        className={classNames('navigationItem', {
          selected: key === selectedSectionType
        })}
        onClick={() => changeSelectedSectionType(key)}>
        {KYC_SECTIONS_META[key].NAVIGATION_HEADING}
      </div>
    ))}
  </div>
);

export default Navigation;
